/* eslint-disable prettier/prettier */

export const leadConstant = {
    FETCHING_LEAD_SUCCESS: 'FETCHING_LEAD_SUCCESS',
    FETCHING_LEAD_FAILED: 'FETCHING_LEAD_FAILED',
    CREATE_LEAD_SUCCESS: 'CREATE_LEAD_SUCCESS',
    CREATE_LEAD_FAILED: 'CREATE_LEAD_FAILED',
}
